import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { StatusService } from '../status.service';
import { ServiceStatusCheck, ServiceStatusResult } from '../service-status-check.model';

/** Wraps StatusService.getStatus() (backoffice-be's /v1/status) as a ServiceStatusCheck. */
@Injectable({ providedIn: 'root' })
export class BackofficeStatusCheck implements ServiceStatusCheck {
  private statusService = inject(StatusService);

  readonly key = 'backoffice-be';
  readonly label = 'Backoffice BE';

  check(): Observable<ServiceStatusResult> {
    return this.statusService.getStatus().pipe(
      map(res => ({ ok: res.status === 'UP', detail: `utente: ${res.username}` })),
      catchError((err: HttpErrorResponse) =>
        of({ ok: false, detail: err.error?.error ?? `HTTP ${err.status}` }),
      ),
    );
  }
}
